import React, { useState } from 'react';
import './Footer.css'
import SectionLabel from '../Common/SectionLabel';
import HeroText from '../Common/HeroText';
import Btn from '../Common/Btn';
import LogoLink from '../Common/LogoLink';

const Footer = () => {

    const [formAnim, setFormAnim] = useState('Footer');


    return ( 
        <>
        <footer className={formAnim} onMouseEnter={() => setFormAnim("Footer FooterAnim")}>
            <div className='FooterMG'></div>
            <div className='FooterSG'></div>


            <SectionLabel SectionLabel="Join Us / 07" className="SectionLabel" />
            <p className='FooterTitle'>
                                    Be Apart of Egypts <span className='green'>
                                        <HeroText
                                        text="Electric"
                                        flex
                                        alpha={false}
                                        stroke={false}
                                        width
                                        weight
                                        italic
                                        textColor="#35A44F"
                                        strokeColor="#5227FF"
                                        minFontSize={64}
                                    /></span> 
                                    Future                                          
                                </p>

            <div className='FooterContact'>
                <p className='ContactTitle'>Get in Touch</p>

                <form className='ContactForm' action="">
                    <div className='ContactInput'>
                        <label className='CInputLabel'>Full Name</label>
                        <input className='CInput' type="text" placeholder='Enter your full name' />
                    </div>

                    <div className='InputDiv'>
                        <div className='ContactInput'>
                            <label className='CInputLabel'>Email</label>
                            <input className='CInput' type="email" placeholder='Enter your email' />
                        </div>
                        <div className='ContactInput'>
                            <label className='CInputLabel'>Phone No</label>
                            <input className='CInput' type="tel" placeholder='Enter your phone number' />
                        </div>
                    </div>

                    <div className='ContactInput'>
                        <label className='CInputLabel'>Message</label>
                        <textarea className='CInputArea' placeholder='Write your message here'></textarea>
                    </div>
                </form>
            </div>

            <Btn BtnText="Submit" className="FormBtn2" />
        </footer>

        <div className='Bottom'>
            <LogoLink />

            <p className='CR'>
                © 2026 Electrify EVs. Powering Egypt's Electric Future.
            </p>
        </div>
        </>
     );
}
 
export default Footer;